module.exports = __webpack_public_path__ + "img/travel-avis.582eb893.jpg";